import { defineMessages } from 'react-intl-next';

export default defineMessages({
	ok: {
		id: 'rovo-onboarding-ok',
		defaultMessage: 'OK',
		description: 'Action button for completing the rovo onboarding spotlight',
	},
	gotIt: {
		id: 'rovo-onboarding-got-it',
		defaultMessage: 'Got it',
		description: 'Action button for completing the rovo onboarding spotlight',
	},
	onboardingStep1Heading: {
		id: 'rovo-onboarding-step-1-heading',
		defaultMessage: 'Search across company apps',
		description: 'Spotlight onboarding step 1 heading',
	},
	onboardingStep1Description: {
		id: 'rovo-onboarding-step-1-description',
		defaultMessage:
			'Choose an app to get more relevant results and filters. For example, filter by Space in Confluence.',
		description: 'Spotlight onboarding step 1 description',
	},
});
